export enum PointOfContactPeriod {
  Daily,
  Weekly,
  Monthly,
}
